import { Observer } from "mobx-react-lite"
import { useHistory } from "react-router"
import { Pages } from "../models/constants"
import { rootStore } from "../StApp"
import Loader from "./Loader"

export const DumpsIndic = () => {

    const history = useHistory()
    const store = rootStore.dumpStore

    function navToDumpPlay() {
        history.push(Pages.DUMP_PLAYGROUND)
    }

    function loadDumpsAndNav() {

        if (store.dumpUsers.length == 0)
            store.fetchDumps()
        else {
            navToDumpPlay()
        }
    }

    return (
        <div className='flex-column center-both' >
            <div className='flex-column center-both relative ' style={{ width: 70, height: 90, flexShrink: 0, border: '1px solid grey', borderRadius: 5 }} onClick={loadDumpsAndNav} >
                <span className="material-icons-outlined" style={{ fontSize: 30 }} >
                    delete_outline
                </span>
                <Observer>{() => {
                    return store.loadProg == 'LOADING' ? <Loader /> : <p>{store.dumpUsers.length > 0 ? store.dumpUsers.length : null}</p>
                }
                }</Observer>

            </div>
        </div>
    )
}